<template>
  <section class="container home">
    <div class="main-pages">
      <router-link to="/competencies" class="page-block blue-1">
        <div class="page-block__icon">
          <svg class="icon-competence">
            <use xlink:href="#competence"></use>
          </svg>
        </div>
        <div class="page-block__title">Оценочные материалы</div>
      </router-link>
      
      <router-link to="/archive" class="page-block blue-6">
        <div class="page-block__icon">
          <svg class="icon-archive">
            <use xlink:href="#archive"></use>
          </svg>
        </div>
        <div class="page-block__title">Архив оценочных материалов</div>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 30px;
}

.main-pages {
  display: flex;
  flex-wrap: wrap;
  a {
    text-decoration: none;
  }
}

.page-block {
  height: 290px;
  border-radius: 5px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding-left: 45px;
  padding-top: 53px;
  padding-right: 39px;
  flex: 1 1 31%;

  transition: all 0.2s ease-in-out;

  .page-block__title {
    font-size: $page-title-font-size;
    line-height: $page-title-line-height;
    color: #fff;
    font-weight: bold;
    width: 69%;
  }

  .page-block__icon {
    min-height: 120px;
  }

  .icon-competence {
    width: 83px;
    height: 65px;
  }
  .icon-normatives {
    width: 84px;
    height: 82px;
  }
  .icon-list {
    width: 83px;
    height: 83px;
  }
  .icon-faq {
    width: 87px;
    height: 87px;
  }
  .icon-managers {
    width: 95px;
    height: 95px;
  }
  .icon-archive {
    width: 83px;
    height: 80px;
  }

  &:hover {
    box-shadow: 0 0 30px 1px rgba(16, 54, 119, 0.6);
  }
}

@include media-breakpoint-only(sm) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
}

@include media-breakpoint-down(sm) {
  .page-block {
    padding-left: 25px;
    padding-right: 0;

    .page-block__title {
      width: 100%;
    }

    .icon-competence {
      width: 105px;
      height: 82px;
    }
    .icon-normatives {
      width: 105px;
      height: 103px;
    }
    .icon-list {
      width: 105px;
      height: 105px;
    }
    .icon-faq {
      width: 105px;
      height: 105px;
    }
    .icon-managers {
      width: 105px;
      height: 105px;
    }
    .icon-archive {
      width: 105px;
      height: 101px;
    }
  }
}
@include media-breakpoint-down(md) {
  .page-block {
    &:nth-child(2n + 2) {
      margin-right: 0;
    }
  }
}

@include media-breakpoint-up(lg) {
  .page-block {
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
}

@include media-breakpoint-only(xs) {
  .page-block {
    margin-right: 0;
    padding-right: 30px;
    padding-left: 30px;
    text-align: center;
    flex: 1 1 51%;
    width: 100%;
  }
  .container {
    padding-left: 34px;
    padding-right: 34px;
  }
}
</style>
